<template>
  <div class="company-introduce-background">
    <div class="company-introduce-banner">
      <div class="company-introduce-container">
        <div class="company-introduce-banner-title">{{ $t("navbar.TypicalLiterature") }}</div>
      </div>

      <img class="company-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="company-introduce-container">

     <div class="company-introduce-content">

       <div class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">{{ $t("navbar.TypicalLiterature") }}</div>
       </div>
       <div class="company-introduce-content-info">
         <div v-for="Case in Case" :key="Case">
           <p class="company-introduce-content-info-text" style="font-size:18px">
             <i class="fa fa-file-pdf-o company-introduce-content-university-fa"></i><a style="font-weight:bold; color:black">{{Case.id}}</a><a :href=Case.paper_url target="_blank">{{Case.paper}}</a>
           </p>
           <p class="company-introduce-content-info-text" style="font-size:18px">
             <i class="fa fa-file-pdf-o company-introduce-content-university-fa"></i>{{Case.name}}:
             <a :href=Case.name_url  target="_blank">{{Case.file_name}}</a>
           </p>
           <p class="company-introduce-content-info-text" style="font-size:18px">
             <i class="fa fa-file-pdf-o company-introduce-content-university-fa"></i>{{Case.inputfile}}:
             <a :href=Case.inputfile_url  target="_blank">{{Case.inputfile_name}}</a>
           </p>
         </div>

       </div>

     </div>
    </div>
  </div>
</template>

<script>
  // import {Case} from '../../helpers/Case_zh'
  export default {
    name: "companyIntroduce",
    data() {
      return{
        // Case
      }
    },
    computed: {
      Case() {
        const lang = this.$i18n.locale;
        try {
          return require(`../../helpers/Case_${lang}.js`).Case;
        } catch {
          return require('../../helpers/Case_zh.js').Case;
        }
      }
    },
    methods:{
      toVedio(){

      }
    }
  }
</script>

<style scoped>
  .company-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .company-introduce-background{
    margin-top: 70px;
  }
  .company-introduce-banner{
    overflow:hidden;
  }
  .company-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .company-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .company-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .company-introduce-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .company-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .company-introduce-content-info{
    margin-top: 50px;
  }
  .company-introduce-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .company-introduce-content-info-title-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight: bolder;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .company-introduce-content-info-title-fa{
    font-size: 22px;
    padding-right: 8px;
  }

  .company-introduce-content-university-fa{
    font-size: 16px;
    padding-right: 8px;
  }

  @media screen and (max-width:482px) {
    .company-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .company-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .company-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .company-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .company-introduce-container{
      max-width: 1068px;
    }
  }

</style>
